<template>
     <div id="autocomplete" class="mobiSearch">
            <div class="mobiSearch__wrap" id="mobiSearchWrap">
                 <input class="mobiSearch__input"
                data-autocomplete
                :placeholder="$t('search')"
                aria-label="Search for Games, Apps, etc..."
                v-model="search_input"
                @keyup="search(search_input)"
            >
                <label id="searchBtn">
                    <span class="icon mobiSearch__icon" id="sear"></span>
                </label>
            </div>
           
            <div id="auto_result" class="mobiAutocomplete">
                <router-link class="mobiAutocomplete__resultItem" v-for="(post, index) in result_search" :key="index" v-html="icon_bold[index]"
                    :to="{
                        name: 'DetailPage',
                        params: { id: post.id }
                    }" >{{ index }}</router-link>
                <p class="autocomplete-result-list" id='searchSuggestion'></p>
            </div>
        </div>
</template>

<script>
import axios from "axios";
import gsap, { TimelineLite } from "gsap";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      search_input: "",
      result_search: {},
      icon_bold: {},
      count: "",
      searchAniTl: null,
    };
  },
  computed: mapGetters(["lang_cutehub", "host_cutehub"]),
  mounted() {
    //search ani timeline instance
    const navigation = document.getElementsByClassName("navigation")[0];
    const widthToExp = navigation.getBoundingClientRect().width - 180;
    const searchSuggestion = document.getElementById("searchSuggestion");
    const mobiSearchWrap = document.getElementById("mobiSearchWrap"),
      backdrop = document.getElementById("backdrop");
    this.initSearchAnimation(widthToExp);
    //click event listeners
    document.getElementById("searchBtn").addEventListener("click", (e) => {
      if (mobiSearchWrap.classList.contains("mobiSearchWrap--expand")) {
        this.search_input = "";
        this.result_search = {};
        searchSuggestion.innerHTML = "";
        searchSuggestion.style.display = "none";
        this.searchAniTl.reverse();
        mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
      } else {
        this.searchAniTl.play();
        mobiSearchWrap.classList.add("mobiSearchWrap--expand");
      }
    });
    document.getElementById("backdrop").addEventListener("click", (e) => {
      this.search_input = "";
      this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
    //search suggestions autocomplete code
    document.getElementById("auto_result").addEventListener("click", (e) => {
      this.search_input = "";
      this.result_search = {};
      searchSuggestion.innerHTML = "";
      searchSuggestion.style.display = "none";
      this.searchAniTl.reverse();
      mobiSearchWrap.classList.remove("mobiSearchWrap--expand");
    });
  },
  methods: {
    initSearchAnimation(widthToExp) {
      this.searchAniTl = gsap.timeline({ paused: true });
      this.searchAniTl
        .to("#logo", { display: "none" })
        .to(".mobiSearch__input", {
          duration: 0.4,
          width: widthToExp,
          opacity: 1,
          visibility: "visible",
          ease: "back.inOut(1.4)",
        })
        .to("#backdrop", { duration: 0.3, opacity: 1, visibility: "visible" });
    },
    search(input) {
      const autoComplete = document.getElementById("auto_result");
      const searchSuggestion = document.getElementById("searchSuggestion");
      autoComplete.style.display = "block";
      var rgxp = new RegExp(input, "gi");

      if (input.length < 1) {
        //if input is empty
        searchSuggestion.style.display = "none";
        searchSuggestion.innerHTML = "";
        this.result_search = {};
      } else {
        let live = `http://cook.grabmobi.com/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=${input}&domain=${this.host_cutehub}`;
        let local = `http://[::1]/PuretechGlobalContentPortal/api/contents/cutemobi_search?token=xB2I1pLjD39Gsa0opKnVnMxEwQyeyIoP6&search=${input}&domain=${this.host_cutehub}`;

        axios
          .get(live)
          .then((res) => {
            let search = res.data.data;
            let count = 0;
            let z = [];

            for (let i = 0; i < search.length; i++) {
              if (count <= 15) {
                this.count = count;
                z.push(search[i]);
              }
              count++;
            }
            this.result_search = z;

            let not_match = require(`../../locales/cutehub/${this.lang_cutehub}.json`);

            if (z.length < 1) {
              //if the input not match with the data
              searchSuggestion.style.display = "block";
              searchSuggestion.innerHTML = not_match["not_match"];
            }

            let res_search = [];
            let bold = [];
            let img = "";
            let icon = "";
            for (let i = 0; i < z.length; i++) {
              searchSuggestion.style.display = "none";
              searchSuggestion.innerHTML = "";

              let icon = "";
              //use class icon
              let icon_class = [];
              if (z[i].class_icon != null) {
                icon_class = JSON.parse(z[i].class_icon);
              } else {
                icon_class = null;
              }

              // if (z[i].class_icon != null) {
              //   //my.1.grabmobi.com as default domain
              //   icon = icon_class['cutemobi.vip']['class'];
              // } else {
              //   icon = icon_class['my.1.grabmobi.com']['class'];;
              // }

              if (icon_class != null) {
                for (let [key, value] of Object.entries(icon_class)) {
                  if (key == this.host_mobiz) {
                    icon = icon_class[key]["class"];
                  } else {
                    icon = icon_class["cutemobi.vip"]["class"];
                  }
                }
              }

              //to show the bold text
              let rs = z[i].content_name;
              let t_char = rs.search(rgxp) + input.length;
              let re = rs.substring(rs.search(rgxp), t_char);
              let str = rs.replace(rgxp, `<b><i>${re}</i></b>`);
              res_search.push(str);

              //use class icon
              let r = res_search[i].replace(
                res_search[i],
                `<span class='${icon}'></span> ${res_search[i]}`
              );

              bold.push(r);
              this.icon_bold = bold;
            }
          })
          .catch((err) => {
            //console.log(err);
          });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.mobiSearch {
  display: inline-block;
  vertical-align: middle;
  position: relative;
}
.mobiSearch__wrap {
  position: relative;
  label {
    margin: 0;
    right: 0;
    top: 50%;
    width: 38px;
    transform: translateY(-50%);
    position: absolute;
    cursor: pointer;
  }
  .icon {
    display: inline-block;
    vertical-align: middle;
    &::before {
      color: #fff;
      font-size: 21px;
    }
  }
}
.mobiSearch__icon {
  &::before,
  &::after {
    content: "";
    margin: auto;
    position: absolute;
    transition: all 0.3s ease-in-out;
  }
  &::before {
    top: 16px;
    right: 0;
    bottom: 0;
    left: 12px;
    width: 10px;
    height: 2px;
    background: #0e0e0f;
    transform: rotate(45deg);
  }

  &::after {
    top: -5px;
    right: 0;
    bottom: 0;
    left: -5px;
    width: 21px;
    height: 21px;
    border-radius: 50%;
    border: 2px solid #0e0e0f;
  }
}

.mobiSearchWrap--expand .mobiSearch__icon {
  &::before {
    top: 0;
    left: 0;
    width: 25px;
    background: #ccc;
  }
  &::after {
    top: 0;
    left: 0;
    width: 25px;
    height: 2px;
    border: none;
    background: #ccc;
    border-radius: 0%;
    transform: rotate(-45deg);
  }
}
.mobiSearch__input {
  appearance: none;
  outline: none;
  box-shadow: none;
  border: 0px;
  width: 38px;
  height: 38px;
  line-height: 38px;
  padding: 12px 15px 12px 25px;
  font-size: 1.2rem;
  background-color: "#fff";
  opacity: 0;
  visibility: visible;
  cursor: pointer;
  border-radius: 20px;
  &:focus {
    box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
  }

  //   transition: width 0.8s cubic-bezier(0, 1.2, 0.4, 1.1);
}
.mobiSearchWrap--expand .mobiSearch__input {
  box-shadow: 0 0 14px 6px rgba(0, 0, 0, 0.3);
}
#auto_result {
  display: none;
}
.mobiAutocomplete {
  position: absolute;
  top: 38px;
  width: 95%;
  left: 0;
  right: 0;
  margin: auto;
  background: #fff;
  max-height: 480px;
  overflow: auto;
}
.mobiAutocomplete__resultItem {
  display: block;
  color: #000;
  padding: 8px;
  text-decoration: none;
  font-weight: 0;
}
/*#autocomplete {
    max-width: 400px;
    margin: 0 auto;
    position: absolute;
    background: white;
    border: 1px solid gainsboro;
    border-radius: 10px;
}

.autocomplete-input{
    max-width: 400px;
    width: 100%;
    border: 0px;
    border-radius: 10px;
    padding: 5px;
}*/

.autocomplete-result-list {
  cursor: pointer;
  display: block;
  color: black;
  text-decoration: none;
  margin: 0px;
  padding: 8px;
  text-transform: uppercase;
}

// #searchSuggestion{
//     display: none;
//     color: black;
// }

/* 
input.autocomplete-input {
    max-width: 400px;
    width: 100%;
} */

.ar_layout {
  .mobiAutocomplete__resultItem {
    direction: rtl;
    text-align: right;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cutehub/Search.vue